import React, { Component } from 'react';

//componentes
import Inicio from './home'

class Index extends Component {

    render(){
        return(
            <div>
                <Inicio />
            </div>
        );
    }

}
export default Index;